import { anyOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isConversationalSettingsResult = objectOf({
  result: objectOf({
    brand_guideline_id: anyOf(string, nullOrUndefined),
    opening_message: anyOf(string, nullOrUndefined),
  }),
});
